
<div class="main-container" [ngClass]="theme.getThemeClass()">
  <!-- Section for client association of distributor devices -->
  @if (this.relationModalService.showClientAssociationModal) {
  <section [ngClass]="theme.getThemeClass()" class="client-association-container">
    <h3 class="container-title">{{ "clientAssociation" | translate }}</h3>
    <label class="thing-label">
      {{ this.relationModalService.thing_name }}
    </label>
    <div class="select-container">
      <select
        class="form-control select"
        [(ngModel)]="this.relationModalService.selectedClient"
      >
        <option value="">{{ 'clientName' | translate }}</option>
        @for (client of this.relationModalService.clientArray; track client.client_id) {
          <option [value]="client.client_id">{{ client.legal_name }}</option>
        }
      </select>
    </div>
  </section>
  }

  <!-- Section fro bin association of distributor devices -->
  @if (this.relationModalService.showBinAssociationModal) {
  <section [ngClass]="theme.getThemeClass()" class="bin-association-container">
    <h3 class="container-title">{{ "binAssociation" | translate }}</h3>
    <label class="thing-label">
      {{ this.relationModalService.thing_name }}
    </label>
    <div class="select-container">
      <select
        class="form-control select"
        [(ngModel)]="this.relationModalService.selectedBin"
      >
        <option value="">{{ 'selectBin' | translate }}</option>
        @for (bin of this.relationModalService.binArray; track bin.bin_id) {
          <option [value]="bin.bin_id">{{ bin.bin_name }}</option>
        }
      </select>
    </div>
  </section>
  }

  <nav class="nav-btn" [ngClass]="theme.getThemeClass()">
    <button [ngClass]="theme.getThemeClass()" class="btn" (click)="closeModal()">{{ "iotModalButtonClose" | translate }}</button>
    <button [ngClass]="theme.getThemeClass()" class="btn" (click)="saveAssociation()">{{ "loginFNewPasswordBtnConfirmNewPw" | translate }}</button>
  </nav>
</div>
